import { QUICK_COMMERCE_APIS } from "@/api_framework/api_config";
import {
  IQuickCommercePincodeListResponse,
  IQuickCommercePincodeListResponseData,
} from "@/api_framework/api_modals/QuickCommerce";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useQuickCommerce } from "../../useQuickCommerce";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export const useQuickCommercePincodeListAPI = () => {
  const [pincodeList, setPincodeList] = useState<IQuickCommercePincodeListResponseData[] | null>(null);
  const quickCommerce = useQuickCommerce();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (cityId: number) => {
      try {
        const accessToken = localStorage.getItem(quickCommerce.localStorage.ACCESS_TOKEN.key);
        if (!cityId) {
          return;
        }
        dispatch(
          setLoading({
            key: "isOnboardPincodeListInProgress",
            status: true,
          }),
        );
        await axios
          .get(`${QUICK_COMMERCE_APIS?.PINCODE_LIST?.baseURL}`, {
            params: { city_id: cityId },
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IQuickCommercePincodeListResponse>) => {
            dispatch(
              setLoading({
                key: "isOnboardPincodeListInProgress",
                status: false,
              }),
            );
            if (res.data.status === true) {
              console.log(res.data.data);
              setPincodeList(res.data.data);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        if (axios.isAxiosError(error)) {
          dispatch(
            setLoading({
              key: "isOnboardCityListInProgress",
              status: false,
            }),
          );
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching city details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, quickCommerce],
  );

  return { pincodeList, execute };
};
